import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuActionCreators } from "../../redux/action-creators";
import { MenuSelectors, UserContextSelectors } from "../../redux/selectors";
import classNames from "classnames";
import { useClickOutside } from "../../hooks";
import { TrackingInfo as trackingInfo } from "../tracking/TrackingInfoMenu";
import { ThemeModeItems } from "../Theme/ThemeMode.items";
import { useThemeModeHandler } from "../Theme/hooks";
import { MessageBrokerUtils } from "../../utils";
import { Channel, Topic } from "../../constants";
import { LocalizationMessages } from "../../localization/messages";
import { useIntl } from "react-intl";
import { SVGIcon2 } from "../common/SVGIconV2";

const AppearanceMenu = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const appearanceMenuVisible = useSelector(
    MenuSelectors.appearanceMenuVisible
  );

  const [componentTrackingInfo, setComponentTrackingInfo] =
    useState(trackingInfo);

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const { setStoreThemeMode, setHtmlThemeMode } = useThemeModeHandler();

  useEffect(() => {
    const appearanceTrackingInfo = {
      dataCategory: "Light-Dark Mode",
      dataAction: "Side Nav",
      dataLabel: formatMessage(LocalizationMessages.themeMode),
      dataValue: ""
    };

    setComponentTrackingInfo(
      trackingInfo
        ? Object.assign({}, trackingInfo, appearanceTrackingInfo)
        : appearanceTrackingInfo
    );
  }, [isMobile, formatMessage]);

  const currentRef = useClickOutside(
    () => {
      dispatch(MenuActionCreators.hideAppearanceMenu());
      dispatch(MenuActionCreators.hideQuickLinksInnerMenu());
    },
    {
      disabled: !appearanceMenuVisible,
      ignoreClass: ["generic-drawer", "do-not-close-Appearance"]
    }
  );

  const publishThemeMode = useCallback(mode => {
    MessageBrokerUtils.publish({
      channel: Channel.USER_INTERACTION,
      topic: Topic.themeModeUpdate,
      headers: {
        publisher: "UAA"
      },
      data: {
        themeMode: mode.code
      }
    });
  }, []);

  const onThemeModeItemClick = useCallback(
    themeMode => {
      if (themeMode) {
        setStoreThemeMode(themeMode);
        setHtmlThemeMode(themeMode);
        publishThemeMode(themeMode);
      }
      dispatch(MenuActionCreators.hideAppearanceMenu());
    },
    [dispatch, setStoreThemeMode, setHtmlThemeMode, publishThemeMode]
  );

  const onCloseClick = () => {
    dispatch(MenuActionCreators.hideAppearanceMenu());
  };

  return (
    <div
      className={classNames("appearance-menu", "do-not-close-Appearance", {
        "drawer-show-left": !isMobile && appearanceMenuVisible,
        "sub-menu": !isMobile,
        "mobile-menu-drawer": isMobile
      })}
      ref={currentRef}
      data-testid={"appearance-menu"}
    >
      {!isMobile && (
        <div className="closeSubMenu">
          <i className="closeSubMenuBtn" onClick={onCloseClick}>
            <SVGIcon2 iconName="close" />
          </i>
        </div>
      )}
      <ThemeModeItems
        trackingInfo={componentTrackingInfo}
        onClick={onThemeModeItemClick}
      />
    </div>
  );
};

export default React.memo(AppearanceMenu);
